export const SHOPIFY_URL =
    'https://admin.shopify.com/store/<shopify_store_name>/subscription/pick_period/basic/monthly?online=true&selected=true';

export const IMAGE_URL =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/968f774fae817f32a25bf2707c0b83ab-1748635176259/Subscribe%20to%20Shopify.png';
